module.exports = __webpack_public_path__ + "static/img/image007.06e5446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image007.png
// module id = tV+y
// module chunks = 1